export default __webpack_public_path__ + "static/media/Background_Code.646e9561.jpeg";